'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _pagination = require('./src/pagination.js');

var _pagination2 = _interopRequireDefault(_pagination);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_pagination2.default.install = function (Vue) {
    Vue.component(_pagination2.default.name, _pagination2.default);
};

exports.default = _pagination2.default;


//////////////////
// WEBPACK FOOTER
// ./~/vue-easytable/libs/v-pagination/index.js
// module id = 1669
// module chunks = 0